import styled, { css } from 'styled-components'
import { Button, ButtonBlock, ButtonPrimary } from '../Button/styles'
import IconAlertInfo from '../../assets/icons/icon-alert-info.svg'
export const Register = styled.section`
  padding: 100px 0;
  background: #fbfbfb;
`

export const WrapperSmall = styled.div`
  margin: auto;
  max-width: 600px;
  position: relative;
  width: 100%;
`

export const RegisterCard = styled.div`
  background: #fff;
  padding: 40px 80px;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  -webkit-box-shadow: 4px 3px 7px 2px rgba(0, 0, 0, 0.05);
  box-shadow: 4px 3px 7px 2px rgba(0, 0, 0, 0.05);

  p.cadastro-description {
    font-size: 15px;
    margin-bottom: 24px;
  }

  p {
    font-size: 12px;
    line-height: 20px;
    margin-top: 0;
  }

  small {
    margin-bottom: 5px;
    font-size: 13px;
    line-height: 22px;
  }

  .alert-info {
    background: #f1f8ff url(${IconAlertInfo}) left 20px center no-repeat;
    color: #1877f2;
    padding: 20px 60px 20px 70px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 20px;
    margin: 20px 0 0 0;
    position: relative;
  }

  .alert-info svg {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 30px;
    top: 50%;
    cursor: pointer;

    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-transition: all 400ms;
    -moz-transition: all 400ms;
    transition: all 400ms;
  }

  .alert-info svg:hover {
    opacity: 0.6;
  }
`

export const Title = styled.h3`
  font-size: 24px;
  font-weight: 500;
  color: #d22630;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: 1170px) {
    font-size: 18px;
    text-align: left;
  }
`
export const ErrorList = styled.ul`
  font-size: 12px;
  margin-bottom: 15px;
`

export const Error = styled.li`
  ${({ theme, isValid, isPasswordEmpty }) => css`
    color: ${isPasswordEmpty ? 'grey' : isValid ? 'green' : 'red'};
    display: flex;
    align-items: center;
    margin-bottom: 2px;

    &::before {
      content: '${isPasswordEmpty ? '\u25cf' : isValid ? '\u2714' : '\u2718'}';
      font-size: 12px;
      padding-right: 2vh;
      height: 16px;
      width: 20px;
      color: ${isPasswordEmpty ? 'grey' : isValid ? 'green' : 'red'};
      display: inline-block;
    }
  `}
`

export const CaptchaContainer = styled.div`
  margin-bottom: 16px;
`

export const ChangeButton = styled.button`
  ${({ theme, disabled }) => css`
    ${Button(theme)}
    ${ButtonPrimary(theme)}
    ${ButtonBlock}
    margin-top: 6px;
    cursor: pointer;

    ${disabled &&
    css`
      background: ${theme.colors.grey};
    `}
  `}
`
